/*
* Overlay JS Class Toggles for: Menu, Search and Book Now
*/
$(document).ready(function($) {

    // Overlay Menu Toggle
    $(".overlaymenutoggle, .overlay-menu-close").on("click", function() {
        $(".overlay-menu, .overlay-menu-mask").toggleClass("overlay-menu-open");
        $("body").toggleClass("no-scroll");
    });   
    
    // Overlay Search Toggle
    $(".searchtoggle, .overlay-search-close").on("click", function() {
        $(".overlay-search, .overlay-search-mask").toggleClass("overlay-search-open");

        if($('.mainnav_scrolled').length === 0){
            $(".mainnav").toggleClass("mainnav_scrolled");
        }

        $("body").toggleClass("no-scroll");
    });  

    // Overlay Book-Now Toggle
    $(".booknowtoggle, .overlay-booknow-close").on("click", function() {
        $(".overlay-booknow, .overlay-booknow-mask").toggleClass("overlay-booknow-open");
        if($('.mainnav_scrolled').length === 0){
            $(".mainnav").toggleClass("mainnav_scrolled");
        }
        $("body").toggleClass("no-scroll");
    });  

    // Overlay Menu Nesting

    $(".overlay_menu_nav_parent").each(function() {
        var parentLink = $(this).children("a");
        var parentMenu = $(this).parent("ul");
        var childMenu = $(this).children("ul");

        childMenu.prepend("<li class='overlay-nav-back'><button class='btn btn-navback'>Back</button></li>");

        var backBtn = childMenu.children(".overlay-nav-back");

        parentLink.on("click", function(e) {
            e.preventDefault();
            parentMenu.addClass("child-is-active");
            childMenu.addClass("is-active");
        });

        backBtn.on("click", function() {
            parentMenu.removeClass("child-is-active");
            childMenu.removeClass("is-active");
        });
    });

});